.text-area-input-container {
  position: relative;
  display: flex;
  flex-direction: column;

  svg {
    position: absolute;
    left: 0.75rem;
    top: 0.8rem;
    bottom: 0.8rem;
    fill: white;
    z-index: 1;
    width: 1.6rem;
  }

  /* The original wrote a second `top` whose value was `hasLabel && '2.5rem'`,
     which styled-components dropped when hasLabel was falsy. */
  &[data-has-label='true'] svg {
    top: 2.5rem;
  }
}

.my-label {
  font-family: Inter, sans-serif;
  font-weight: 600;
  color: var(--white-default);
  font-size: 1.4rem;
  letter-spacing: 0.7px;
  line-height: 1.1rem;
  display: none;
  margin-bottom: 1.2rem;

  b {
    color: var(--color-primary);
  }

  &[data-has-label='true'] {
    display: inline;
  }
}

.input {
  position: relative;
  min-height: 14.4rem;
  /* Both resize props default to false and no caller passes either, so this is
     always `none` today. Note the original declared `resize` twice, vertical
     last, so the vertical branch always overrode the horizontal one — meaning
     horizontalResize never actually took effect. Order preserved below. */
  resize: none;
  box-sizing: border-box;
  border-radius: 0.6rem;
  font-family: Inter, sans-serif;
  font-size: 1.6rem;
  letter-spacing: 0.3px;
  line-height: 1.6rem;
  border: 1px solid var(--color-grey-7);
  padding: 1.2rem 1.6rem;
  background-color: transparent;
  color: var(--white-default);

  &[data-horizontal-resize='true'] {
    resize: horizontal;
  }

  &[data-vertical-resize='true'] {
    resize: vertical;
  }

  &[data-has-icon='true'] {
    padding: 1.2rem 1.6rem 1.2rem 3.6rem;
  }

  &[data-has-error='true'] {
    border: 1px solid var(--color-error);
  }

  &:focus {
    border: 1px solid var(--color-secondary);
  }

  &[data-has-error='true']:focus {
    border: 1px solid var(--color-error);
  }
}

.error {
  position: absolute;
  right: 0;
  bottom: -2.4rem;
  height: 1.6rem;
  color: var(--color-error);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: -0.2px;
  line-height: 1.6rem;
  text-align: right;
}
